import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import Contact from "./sections/Contact";
import TheAllInOneStudentBundle from "./sections/TheAllInOneStudentBundle";
import DirectContactStrip from "./sections/DirectContactStrip";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <Contact />
      <TheAllInOneStudentBundle />
      <DirectContactStrip />
      <Footer />
    </div>;
}